<template>
	<div class="option-group" v-if="multi">
		<el-checkbox-group :disabled="readOnly" :value="value" @input="emitSelection">
			<el-checkbox v-for="(option, index) in options" :label="index" :key="index">
				<h3>{{option.title}}</h3>
				<p>{{option.description}}</p>
			</el-checkbox>
		</el-checkbox-group>
	</div>
	<div class="option-group" v-else>
		<el-radio-group :disabled="readOnly" :value="value" @input="emitSelection">
			<el-radio v-for="(option, index) in options" :label="index" :key="index">
				<h3>{{option.title}}</h3>
				<p>{{option.description}}</p>
			</el-radio>
		</el-radio-group>
	</div>
</template>

<script>
// Field Prop needs to be passed in as uppercase camel case
export default{
	props: {
		readOnly:{
			type:Boolean,
			default:false
		},
		options: Array,
		value: [Array, Number],
		multi: {
			type: Boolean,
			default: false
		}
	},
	methods:{
		emitSelection(payload){
			this.$emit('input', payload);
		}
	}
}
</script>

<style lang="scss">
.option-group {
	h3 {
		margin:0;
	}
	p {
		margin:0;
	}
	.el-radio-group, .el-checkbox-group{
		width:100%;
	}
	.el-radio, .el-checkbox{
		white-space:normal;
		border:1px solid #DCDFE6;
		padding:0;
		margin-right: 0px;
		margin-bottom:10px;
		padding:10px 15px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.el-radio.is-checked, .el-checkbox.is-checked{
		border:1px solid #2B98FF;
		background-color:#2B98FF;
		color:white !important;
	}
	.el-radio.is-checked h3, .el-radio.is-checked p, .el-checkbox.is-checked h3, .el-checkbox.is-checked p {

		color:white;
	}
	.el-radio+.el-radio, .el-checkbox+.el-checkbox{
		margin-left:0px;
	}
	.el-checkbox__input, .el-radio__input{margin-right:9px;}
	.el-radio__label, .el-checkbox__label{padding:0 !important;}
	.el-checkbox__label, .el-radio__label{display:inline-block;width:95%;margin-left:9px;}
	.el-radio__inner, .el-checkbox__inner{
		border:1px solid #C0C4CC;
	}
	.el-radio__input.is-checked .el-radio__inner, .el-checkbox__input.is-checked .el-checkbox__inner{
		border-color: white;
		background: white;
	}
	.el-radio__inner.is-checked::after, .el-checkbox__inner.is-checked::after{
		background-color:#2B98FF;
	}
	.el-checkbox__inner::after{
		border-color:#2B98FF;
	}
}

</style>
